














































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { TreatmentMasterListsApi } from "../../../apis";
import { PutTreatmentMasterListRequest } from "../../../apis/model/put-treatment-master-list-request";
import { PostTreatmentMasterListRequest } from "../../../apis/model/post-treatment-master-list-request";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { TYPE, ACTION } from "./";
@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class MasterListDialog extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  @Prop({ default: false }) value: Boolean;
  @Prop({}) mode: string;
  @Prop({}) selectedPermisstion: any;
  @Prop({}) treatmentType: string;
  titleAdd = "";
  titleEdit = "";
  buttonAdd = "";
  buttonEdit = "";
  content = "";

  get editMode() {
    return this.mode === ACTION.EDIT;
  }
  get newMode() {
    return this.mode === ACTION.NEW;
  }
  get getContent() {
    switch (this.treatmentType) {
      case TYPE.PRODUCT: {
        return (this.content = this.$t("text.productName").toString());
        break;
      }
      case TYPE.INSECT: {
        return (this.content = this.$t("text.insectName").toString());
        break;
      }
      case TYPE.PACKAGE: {
        return (this.content = this.$t("text.packageName").toString());
        break;
      }
      case TYPE.TECHNIQUE: {
        return (this.content = this.$t("text.techniqueName").toString());
        break;
      }
      case TYPE.SETPOINT_PARAMETERS: {
        return (this.content = this.$t("text.setpointNamePara").toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get getTitle() {
    switch (this.treatmentType) {
      case TYPE.PRODUCT: {
        return (this.titleAdd = this.$t("text.addProduct").toString());
        break;
      }
      case TYPE.INSECT: {
        return (this.titleAdd = this.$t("text.addInsect").toString());
        break;
      }
      case TYPE.PACKAGE: {
        return (this.titleAdd = this.$t("text.addPackage").toString());
        break;
      }
      case TYPE.TECHNIQUE: {
        return (this.titleAdd = this.$t("text.addTechnique").toString());
        break;
      }
      case TYPE.SETPOINT_PARAMETERS: {
        return (this.titleAdd = this.$t("text.addSetpointPara").toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get getTitleEditMode() {
    switch (this.treatmentType) {
      case TYPE.PRODUCT: {
        return (this.titleEdit = this.$t("text.updateProduct").toString());
      }
      case TYPE.INSECT: {
        return (this.titleEdit = this.$t("text.updateInsect").toString());
      }
      case TYPE.PACKAGE: {
        return (this.titleEdit = this.$t("text.updatePackage").toString());
      }
      case TYPE.TECHNIQUE: {
        return (this.titleEdit = this.$t("text.updateTechnique").toString());
      }
      case TYPE.SETPOINT_PARAMETERS: {
        return (this.titleEdit = this.$t("text.updateSetpoint").toString());
      }
      default: {
      }
    }
  }
  get getButtonAdd() {
    switch (this.treatmentType) {
      case TYPE.PRODUCT: {
        return (this.buttonAdd = this.$t("button.addProduct").toString());
        break;
      }
      case TYPE.INSECT: {
        return (this.buttonAdd = this.$t("button.addInsect").toString());
        break;
      }
      case TYPE.PACKAGE: {
        return (this.buttonAdd = this.$t("button.addPackage").toString());
        break;
      }
      case TYPE.TECHNIQUE: {
        return (this.buttonAdd = this.$t("button.addTechnique").toString());
        break;
      }
      case TYPE.SETPOINT_PARAMETERS: {
        return (this.buttonAdd = this.$t(
          "button.addSetpointParameters"
        ).toString());
        break;
      }
      default: {
        break;
      }
    }
  }
  get show() {
    return this.value;
  }

  set show(value) {
    this.$emit("input", value);
  }

  resetForm() {
    this.selectedPermisstion.treatmentName = null;
    const refForm: any = this.$refs.observer;
    refForm.reset();
  }

  onSave() {
    (this as any).$refs.observer.validate().then((success) => {
      if (!success) {
        return;
      }
      this.addProduct();
    });
  }

  async addProduct() {
    this.$util.showLoading();
    try {
      const body = {
        treatmentName: this.selectedPermisstion.treatmentName,
        treatmentType: this.treatmentType,
      };
      await new TreatmentMasterListsApi().addTreatment({
        postTreatmentMasterListRequest: body as PostTreatmentMasterListRequest,
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.resetForm();
      (this as any).$emit("onSave", "saved");
      this.$util.hideLoading();
    }
  }

  async onEdit() {
    const res = await new TreatmentMasterListsApi().getTreatmentById({
      id: this.selectedPermisstion.id,
    });
    if (
      res.data.data.treatmentName === this.selectedPermisstion.treatmentName
    ) {
      return (this.show = false);
    }
    (this as any).$refs.observer.validate().then((success) => {
      if (!success) {
        return;
      }
      this.updateProduct();
    });
  }

  async updateProduct() {
    this.$util.showLoading();
    try {
      const body = {
        status: this.selectedPermisstion.status,
        treatmentName: this.selectedPermisstion.treatmentName,
        treatmentType: this.treatmentType,
      };
      const res = await new TreatmentMasterListsApi().postCheckExist({
        postTreatmentMasterListRequest: body as PostTreatmentMasterListRequest,
      });
      if (res.data.messages.length === 0) {
        await new TreatmentMasterListsApi().updateTreatment({
          id: this.selectedPermisstion.id,
          putTreatmentMasterListRequest: body as PutTreatmentMasterListRequest,
        });
      }
    } catch (error) {
      this.$util.showError(error);
    } finally {
      (this as any).$emit("onCloseEdit", "closeEdit");
      this.$util.hideLoading();
    }
  }

  onClose() {
    this.$emit("onClose", "closed");
    this.resetForm();
  }

  @Watch("show")
  onShowChanged(value: string, oldValue: string) {
    if (!value) this.onClose();
  }
}
